import React from 'react';
import { Link } from 'react-router-dom';
import { Icon } from '@blueprintjs/core';
import './Footer.scss';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer__container">
        <div className="footer__main">
          <div className="footer__brand">
            <Link to="/" className="footer__logo">
              <span className="footer__logo-name">Rolita Cargill</span>
              <span className="footer__logo-tagline">Living Benefits Specialist</span>
            </Link>
            <p className="footer__description">
              Protecting families with modern life insurance that works while you're still alive.
              Discover the power of Living Benefits.
            </p>
          </div>

          <div className="footer__links">
            <div className="footer__column">
              <h4 className="footer__heading">Quick Links</h4>
              <ul className="footer__list">
                <li><Link to="/">Home</Link></li>
                <li><Link to="/living-benefits">Living Benefits</Link></li>
                <li><Link to="/about">About</Link></li>
                <li><Link to="/contact">Contact</Link></li>
              </ul>
            </div>

            <div className="footer__column">
              <h4 className="footer__heading">Services</h4>
              <ul className="footer__list">
                <li><Link to="/living-benefits">Life Insurance</Link></li>
                <li><Link to="/living-benefits">Critical Illness Protection</Link></li>
                <li><Link to="/living-benefits">Mortgage Protection</Link></li>
                <li><Link to="/contact">Free Consultation</Link></li>
              </ul>
            </div>

            <div className="footer__column">
              <h4 className="footer__heading">Contact</h4>
              <ul className="footer__list footer__list--contact">
                <li>
                  <Icon icon="envelope" size={14} />
                  <a href="mailto:rolita@livingbenefits.com">rolita@livingbenefits.com</a>
                </li>
                <li>
                  <Icon icon="phone" size={14} />
                  <a href="tel:+15551234567">(555) 123-4567</a>
                </li>
                <li>
                  <Icon icon="map-marker" size={14} />
                  <span>Serving clients nationwide</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="footer__bottom">
          <p className="footer__copyright">
            &copy; {currentYear} Rolita Cargill. All rights reserved.
          </p>
          <p className="footer__disclaimer">
            This website is for informational purposes only. Insurance products and availability
            may vary by state. Please consult with a licensed insurance professional for specific advice.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
